<dx-popup class="popup" [showTitle]="true"
  title="Debug" [dragEnabled]="false" [showCloseButton]="true"
  [hideOnOutsideClick]="true"
  [(visible)]="debugVisible">
  <div *dxTemplate="let data of 'content'">
    <app-jsonviewer [json]="debugInfo"></app-jsonviewer>
  </div>
</dx-popup>
